// Shape Categories Panel Component
// Organized for Supabase Migration

import React from 'react';
import { Grid, ChevronDown, ChevronUp } from 'lucide-react';
import { getCategoryNameById } from '../utils/sketchUtils.js';

export const ShapeCategoriesPanel = ({
  allSketches,
  groupedSketches,
  expandedCategory,
  toggleCategory,
  selectedSketch,
  selectSketch
}) => {
  return (
    <div className="bg-gray-50 rounded-lg p-4">
      <h3 className="text-lg font-semibold mb-3 flex items-center gap-2">
        <Grid className="w-5 h-5" />
        Shape Categories ({allSketches.length} total)
      </h3>
      <div className="space-y-2 max-h-96 overflow-y-auto">
        {Object.entries(groupedSketches).map(([categoryId, categorySketchesArray]) => (
          <div key={categoryId} className="border border-gray-200 rounded">
            <button
              onClick={() => toggleCategory(categoryId)}
              className="w-full text-left p-3 bg-white hover:bg-gray-50 flex items-center justify-between rounded"
            >
              <span className="font-medium text-sm">
                {getCategoryNameById(categoryId) || categoryId} ({categorySketchesArray.length})
                {categoryId === "generated-from-image" && (
                  <span className="ml-2 text-xs bg-green-100 text-green-700 px-2 py-1 rounded">AI Generated</span>
                )}
                {categoryId.startsWith("imported") && (
                  <span className="ml-2 text-xs bg-blue-100 text-blue-700 px-2 py-1 rounded">Imported</span>
                )}
                {categoryId === "function-analysis" && (
                  <span className="ml-2 text-xs bg-purple-100 text-purple-700 px-2 py-1 rounded">New!</span>
                )}
                {categoryId === "navigation-geometry" && (
                  <span className="ml-2 text-xs bg-orange-100 text-orange-700 px-2 py-1 rounded">New!</span>
                )}
                {categoryId === "geometry-constructions" && (
                  <span className="ml-2 text-xs bg-pink-100 text-pink-700 px-2 py-1 rounded">New!</span>
                )}
              </span>
              {expandedCategory === categoryId ? 
                <ChevronUp className="w-4 h-4" /> : 
                <ChevronDown className="w-4 h-4" />
              }
            </button>
            {expandedCategory === categoryId && (
              <div className="p-2 bg-gray-50">
                {categorySketchesArray.map((sketch) => (
                  <button
                    key={sketch.index}
                    onClick={() => selectSketch(sketch.index)}
                    className={`w-full text-left p-2 mb-1 rounded text-sm transition-colors ${
                      selectedSketch === sketch.index
                        ? 'bg-blue-100 text-blue-800 border border-blue-300'
                        : 'bg-white hover:bg-gray-100 border border-gray-200'
                    }`}
                  >
                    {sketch.name}
                    {sketch.isGenerated && (
                      <span className="ml-2 text-xs bg-green-100 text-green-700 px-1 py-0.5 rounded">AI</span>
                    )}
                    {sketch.isImported && (
                      <span className="ml-2 text-xs bg-blue-100 text-blue-700 px-1 py-0.5 rounded">Import</span>
                    )}
                  </button>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
